import { extractContactNumber } from '@healthhub/react-ui';

import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_FEDERATED_USER_PROFILE_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { FederatedUserProfile, GetFederatedUserProfileResult } from '../types/getFederatedUserProfile.types';

export const FEDERATED_PROFILES_TAGS = 'getFederatedUserProfile';

export const getFederatedUserProfile = (builder: BuilderType) =>
  builder.query<GetFederatedUserProfileResult, { Secure?: boolean }>({
    providesTags: [FEDERATED_PROFILES_TAGS],
    query: () => ({
      method: 'POST',
      url: GET_FEDERATED_USER_PROFILE_URL,
    }),
    transformResponse: (response: GenericApiResponse<FederatedUserProfile[]>) => {
      if (hasCcdpSuccess(response)) {
        return {
          Profile: {
            ...response.Result?.[0],
            IsFederatedProfile: true,
            Mobile: response.Result?.[0].Mobile ? extractContactNumber(response?.Result?.[0]?.Mobile) : undefined,
            SyncPromptDisabled: true,
          },
        };
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
